import * as React from 'react';
import IconButton from '../common/IconButton';
import NewToolbarItemScroller from '../common/toolbar-item-scroller/NewToolbarItemScroller';
import CurrentToolIcon from '../header-toolbar/CurrentToolIcon';
import { connect } from 'react-redux';
import { Dispatch, Action } from 'redux';
import { Publication, AppStates } from '../../../../..';
import ExtraToolIconButton from './ExtraToolIconButton';
import { PagesState } from '../../reducers/pages';
import {
  createActionForExtraTool,
  getContentExtraToolsForCurrentPage,
} from '../../helpers/extraTools';

interface HeaderToolbarExtraToolsLevelProps {
  readonly isVertical: boolean;
  readonly pages: PagesState;
  readonly publication: Publication;
  readonly popToTopLevel: () => void;
  readonly dispatch: Dispatch<Action>;
}

const HeaderToolbarExtraToolsLevel: React.SFC<
  HeaderToolbarExtraToolsLevelProps
> = React.memo((props) => {
  const { isVertical, pages, publication, dispatch } = props;
  const { resourceDir } = publication;
  const extraTools = getContentExtraToolsForCurrentPage(pages, publication);

  const buttons = [];
  for (const definition of publication.extraToolDefinitions) {
    if (extraTools.indexOf(definition.id) < 0) {
      continue;
    }

    buttons.push(
      <ExtraToolIconButton
        key={definition.id}
        src={`${resourceDir}/${definition.icon}`}
        title={definition.name}
        onClick={createActionForExtraTool(pages, publication, definition, dispatch)} />,
    );
  }

  return <>
    <CurrentToolIcon />

    {buttons.length > 0
      ? <NewToolbarItemScroller vertical={isVertical} alignEnd={false} scrollButtons={true}>
          {buttons}
        </NewToolbarItemScroller>
      : null}

    <IconButton
      title="戻る"
      imagePath="images/tool-icons/new/btn_top/btn_top"
      onClick={props.popToTopLevel} />
  </>;
});

const mapStateToProps = (states: AppStates) => {
  const { publication, pages } = states;
  if (publication === undefined) {
    throw new Error('Empty publication.');
  }

  return { pages, publication };
};

export default connect(mapStateToProps)(HeaderToolbarExtraToolsLevel);
